import { useEffect } from "react";
import Lenis from "lenis";

export const lenisRef = { current: null };

export const useSmoothScroll = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);
};

export const scrollTop = () => {
  if (lenisRef.current) lenisRef.current.scrollTo(0, { immediate: true });
  else window.scrollTo(0, 0);
};
